import axios, { CancelTokenSource } from 'axios';
import dayjs from 'dayjs';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import download from 'downloadjs';

import Button from '../../components/forms/button/Button';
import Contact from '../../components/shared/contact/Contact';
// import Icon from '../../components/shared/icon/Icon';
import Modal from '../../components/shared/modal/Modal';
import ReadMore from '../../components/shared/readmore/ReadMore';

import { IApplicationState } from '../../store/applicationState';
import { fetchGroupMeetings, fetchGroupMembers, fetchGroupMessages, fetchGroup } from '../../store/group/groupActions';
import { IGroup, IGroupMember, IMeeting, IGroupMessage } from '../../store/group/groupState';
// import getConfiguration from '../../services/environment';
import * as groupService from '../../services/group';

import Documents from './Documents';
import Meetings from './Meetings';
import Members from './Members';
import Messages from './Messages';
import Practical from './Practical';

import * as helpers from '../../genericExtensions';

export interface IRouterParams {
    id: string;
}

interface IState {
    cancelToken: CancelTokenSource;
    downloading: boolean;
    greetingModalDismissed: boolean;
}

interface IOwnProps {
    currentGroupMember?: IGroupMember;
    group?: IGroup;
    isLoading: boolean;
    members
    : IGroupMember[];
    meetings: IMeeting[];
    messages: IGroupMessage[];
    showGreetingModal: boolean;
    viewerIsDi: boolean;
    userId: string;
}

interface IDispatchProps {
    fetchGroupMembers: typeof fetchGroupMembers;
    fetchGroupMeetings: typeof fetchGroupMeetings;
    fetchGroupMessages: typeof fetchGroupMessages;
    fetchGroup: typeof fetchGroup;
}

type Props = IOwnProps & IDispatchProps & RouteComponentProps<IRouterParams>;
type State = IState;

class GroupIndex extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            cancelToken: axios.CancelToken.source(),
            downloading: false,
            greetingModalDismissed: false
        }

        if (!this.props.group || !this.props.group.id) {
            this.props.fetchGroup(this.props.match.params.id);
        } else {
            this.fetchData();
        }
    }

    public async componentDidUpdate(prevProps: Props) {
        if (prevProps.group !== this.props.group) {
            if (!this.props.group) {
                this.props.fetchGroup(this.props.match.params.id);
            } else if (!prevProps.group || prevProps.group.id !== this.props.group.id) {
                await this.fetchData();
            }
        }
    }

    public componentWillUnmount() {
        this.state.cancelToken.cancel();
    }

    // Filter where attachments isfavorite
    // this.props.messages.reduce((prev, current) => prev.concat(current.attachments.filter(a => a.isFavorite)), [] as IEmailAttachment[])

    public render() {
        const hasUpcomingMeetings = this.props.meetings.filter(m => dayjs(m.startTime).endOf('day').isAfter(dayjs())).length > 0;

        return <React.Fragment>
            <Practical group={this.props.group!} groupMembers={this.props.members} />
            <Documents title="Dokumenter" group={this.props.group} messages={this.props.messages} meetings={this.props.meetings} />
            {hasUpcomingMeetings && this.renderMeetings()}
            <Messages title="Beskeder" group={this.props.group} groupMessages={this.props.messages} groupMembers={this.props.members} isDi={this.props.viewerIsDi} />
            {!hasUpcomingMeetings && this.renderMeetings()}
            <Members title='Deltagere' members={this.props.members} isDi={this.props.viewerIsDi} group={this.props.group} download={this.downloadCsv} downloading={this.state.downloading} />
            
            <Modal show={this.props.showGreetingModal && !this.state.greetingModalDismissed} onClose={this.dismissModal}>
                <div className="rich-text">
                    <h3>Velkommen til {this.props.group && this.props.group.name}</h3>
                    {this.props.group && this.props.group.description &&
                        <p>
                            <ReadMore text={this.props.group.description} readMoreCutoffLength={140} />
                        </p>
                    }
                </div>
                <div className="rich-text">
                    <h5>Din profil ser lige nu sådan ud:</h5>
                </div>
                {this.props.currentGroupMember && <Contact member={this.props.currentGroupMember} modifierClass="contact--medium" />}
                <div className="rich-text">
                    <h5>Få mest ud af gruppen - præsenter dig selv</h5>
                </div>
                <a href={`/Profile/${this.props.userId}`}>
                    <Button modifierClass="button--primary button--large">
                        <span className="text">Rediger profil - tilføj foto</span>
                    </Button>
                </a>
                {/* 
                <Button modifierClass="button--primary button--large has-icon" onClick={this.connectLinkedIn}>
                    <span className="icon"><Icon name="sociallinkedin" /></span>
                    <span className="text">Hent foto og beskrivelse fra LinkedIn</span>
                </Button>
                <div className="modal__content__form__actions">
                    <p><a href={`/Profile/${this.props.userId}`}>Udfyld selv oplysninger</a></p>
                </div>
                */} 
            </Modal>
        </React.Fragment>;
    }

    private renderMeetings = () => {
        return this.props.group && this.props.group.enabled && <Meetings group={this.props.group} groupIdFallback={this.props.match.params.id} meetings={this.props.meetings} loading={this.props.isLoading} isDi={this.props.viewerIsDi} />
    }

    // private connectLinkedIn = async () => {
    //     const baseUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    //     const configuration = await getConfiguration();

    //     window.location.href = `${configuration.diLoginAuthority}/Account/ConnectLinkedIn?returnUrl=${baseUrl}/Profile/${this.props.userId}%3Fsync=true`;
    // }

    private async fetchData() {
        if (this.props.group && this.props.group.id) {
            const groupTask = this.props.fetchGroup(this.props.match.params.id);
            const meetingsTask = this.props.fetchGroupMeetings(this.props.group.id, this.state.cancelToken);
            const messagesTask = this.props.fetchGroupMessages(this.props.group.id, this.state.cancelToken);
            const membersTask = this.props.fetchGroupMembers(this.props.group.id, this.state.cancelToken);

            await Promise.all([groupTask, messagesTask, meetingsTask, membersTask]);
        }
    }

    private dismissModal = () => this.setState({ greetingModalDismissed: true });

    private downloadCsv = async () => {
        if (!this.props.group) {
            return;
        }

        this.setState({
            downloading: true
        });

        const csv = await groupService.downloadGroupMembers(this.props.group.id!, this.state.cancelToken);

        download(csv,
            `medlemmer-${this.props.match.params.id}.csv`,
            'text/csv');

        this.setState({
            downloading: false
        });
    }
}

const mapStateToProps = (state: IApplicationState, ownProps: RouteComponentProps<IRouterParams>): IOwnProps => {
    const viewerIsDi = state.oidc.user.profile.role === 'DI';
    const userId = state.oidc.user.profile.Id;
    const potentialGroupIds = state.groupData.groups.groups.allIds.filter(id => {
        const g = state.groupData.groups.groups.byId[id];
        return g.alias === ownProps.match.params.id || g.id === ownProps.match.params.id;
    });
    const groupId = (potentialGroupIds.length && potentialGroupIds[0]) || ownProps.match.params.id;
    const members = state.groupData.members.byId[groupId];
    const groupMeetings = state.groupData.meetings.byId[groupId];
    const groupMessages = state.groupData.messages.byId[groupId];
    const group = state.groupData.groups.groups.byId[groupId];
    const groupMembers = members ? helpers.all(members.members) : [];
    const currentGroupMember = members && state.person.currentUser ? groupMembers.firstOrDefault(m => m.diNumber === state.person.currentUser!.diNumber) : undefined;

    return {
        currentGroupMember,
        group,
        isLoading: state.groupData.groups.isLoading && !group,
        meetings: groupMeetings ? groupMeetings.filter(m => m.status !== 'Cancelled') : [],
        members: groupMembers,
        messages: groupMessages,
        showGreetingModal: !!state.person.currentUser && !!currentGroupMember && !!group && group.showMembersInfo !== 'none' && groupMembers.length > 0 && state.person.currentUser.showGreeting,
        viewerIsDi,
        userId
    };
}

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    fetchGroupMeetings: (groupId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(fetchGroupMeetings(groupId, cancelToken)),
    fetchGroupMembers: (groupId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(fetchGroupMembers(groupId, cancelToken)),
    fetchGroupMessages: (groupId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(fetchGroupMessages(groupId, cancelToken)),
    fetchGroup: (groupId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(fetchGroup(groupId, cancelToken))
});

const container = withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupIndex));

export default container;